import React from 'react'
import Image from 'next/image'
import PropTypes from 'prop-types'
import { Text } from '@paper-monster/web/src/components/common'

import BuyNowCta from '@/components/BuyNowCta'
import TryFreeCta from '@/components/TryFreeCta'

import styles from './BottomCTA.module.scss'

export default function BottomCTA({ t }) {
  return (
    <section className={styles.section} id="trial">
      {/* Decorative circles - left */}
      <div className={styles.circlesLeft}>
        <div className={styles.circle} />
        <div className={styles.circle} />
        <div className={styles.circle} />
      </div>

      {/* Decorative circles - right */}
      <div className={styles.circlesRight}>
        <div className={styles.circle} />
        <div className={styles.circle} />
        <div className={styles.circle} />
      </div>
      <div className={styles.circlesBottom}>
        <div className={styles.circle} />
        <div className={styles.circle} />
        <div className={styles.circle} />
      </div>

      {/* Content */}
      <div className={styles.inner}>
        <Text.H2 className={styles.title}>{t.title}</Text.H2>
        <Text.P className={styles.subtitle}>{t.subtitle}</Text.P>
        <Text className={styles.price}>{t.price} <span className={styles.per}>{t.per}</span></Text>
        <div className={styles.ctaRow}>
          <TryFreeCta buttonMessageId={null} className={styles.ctaBtn} size="xlTall">
            {t.cta}
            <img alt="" className={styles.ctaArrow} height={16} src="/arrow-right.svg" width={16} />
          </TryFreeCta>
          <BuyNowCta className={styles.buyNowBtn} messageId={null} size="xlTall" variant="secondary">{t.buyNow}</BuyNowCta>
        </div>
        <div className={styles.badges}>
          <div className={styles.badge}>
            <Image alt="" height={18} src="/check-icon.svg" width={18} />
            <Text className={styles.badgeText}>{t.cancelAnytime}</Text>
          </div>
          <div className={styles.badge}>
            <Image alt="" height={18} src="/sheild-icon.svg" width={18} />
            <Text className={styles.badgeText}>{t.moneyBack}</Text>
          </div>
          <div className={styles.badge}>
            <Image alt="" height={18} src="/check-icon.svg" width={18} />
            <Text className={styles.badgeText}>{t.taxReady}</Text>
          </div>
        </div>
      </div>
    </section>
  )
}

BottomCTA.propTypes = {
  t: PropTypes.shape({
    title: PropTypes.string.isRequired,
    subtitle: PropTypes.string.isRequired,
    cta: PropTypes.string.isRequired,
    buyNow: PropTypes.string.isRequired,
    price: PropTypes.string.isRequired,
    per: PropTypes.string.isRequired,
    cancelAnytime: PropTypes.string.isRequired,
    moneyBack: PropTypes.string.isRequired,
    taxReady: PropTypes.string.isRequired,
  }).isRequired,
}
